import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {ConfigValidationFunction, AdditionalConfigValidationFunctions} from '../StepConfigValidationTypes';
import * as Helpers from './StepConfigValidationHelpers';

const MIN_PRECISION = 0;
const MAX_PRECISION = 20;

const validateConfig: ConfigValidationFunction<PipelineStepType.FORMAT_COLUMNS, 0> = (
  config,
  {'Input dataset': [dataFrameSpec]}
) => {
  const columns = config.formatColumns.map((fc) => fc.column);
  const duplicateColumnsMsg = Helpers.getDuplicateColumnsMessage(
    dataFrameSpec,
    columns,
    'Cannot format the same column more than once.'
  );
  const precisionErrors = config.formatColumns
    .filter(
      (fc) =>
        fc.format.type === 'NUMERIC' &&
        (fc.format.precision < MIN_PRECISION || fc.format.precision > MAX_PRECISION)
    )
    .map((fc) => {
      const displayName = Helpers.getColumnsDisplayText(dataFrameSpec, [fc.column]) ?? fc.column;
      return `Precision for ${displayName} must be between ${MIN_PRECISION} and ${MAX_PRECISION}.`;
    });
  const noColumnsMsg = columns.length >= 1 ? null : 'Must format at least one column.';
  return Helpers.coalesceMessages(duplicateColumnsMsg, noColumnsMsg, ...precisionErrors);
};

export default {
  stepType: PipelineStepType.FORMAT_COLUMNS,
  stepVersion: 0,
  validateConfig,
} satisfies AdditionalConfigValidationFunctions<PipelineStepType.FORMAT_COLUMNS, 0>;
